export default __webpack_public_path__ + "static/media/logo-bank-2.ec8e1398.png";